import { ClipLoader } from "react-spinners";
import { LoaderSizeMarginProps } from "react-spinners/helpers/props";

const SpinLoader: React.FC<LoaderSizeMarginProps> = (props) => {
  return (
    <div className="h-100 w-100 d-flex justify-content-center align-items-center">
      <ClipLoader size="50" color="purple" {...props} />
    </div>
  );
};

export default SpinLoader;
